import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { withApollo } from "@catchoftheday/graphql-utils";
import { Alert, Heading, Link, Text } from "@catchoftheday/cg-components";
import { ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY, ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY, ONEPASS_APP_EXPERIMENT } from "@catchoftheday/common-vendors";
import { emitMigrationFlashMessageImpression, useExperiment } from "@catchoftheday/analytics";
import { getQueryStringValue } from "@header-app/utilities";
import { FLASH_BANNER_MIGRATION_ERROR_MSG, FLASH_BANNER_MIGRATION_SUCCESS_MSG, FLASH_BANNER_MIGRATION_SUCCESS_DOUBLE_SUB_MSG } from "@header-app/consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var FlashMessageBanner = function FlashMessageBanner(_ref) {
  var _ref$isMicrofrontend = _ref.isMicrofrontend,
      isMicrofrontend = _ref$isMicrofrontend === void 0 ? false : _ref$isMicrofrontend;

  var _useState = useState(false),
      showAlert = _useState[0],
      setShowAlert = _useState[1];

  var _useState2 = useState("default"),
      variant = _useState2[0],
      setVariant = _useState2[1];

  var _useState3 = useState(),
      bannerMessage = _useState3[0],
      setBannerMessage = _useState3[1];

  var _useState4 = useState("dark"),
      theme = _useState4[0],
      setTheme = _useState4[1];

  var _useExperiment = useExperiment([ONEPASS_APP_EXPERIMENT]),
      _useExperiment$varian = _slicedToArray(_useExperiment.variants, 1),
      onePassAppExperiment = _useExperiment$varian[0],
      isExperimentLoading = _useExperiment.loading;

  var isOnePassAppExperiment = (onePassAppExperiment === null || onePassAppExperiment === void 0 ? void 0 : onePassAppExperiment.bucket) === 1;
  var paramMigrationDoubleSubs = getQueryStringValue(ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY);
  var paramMigrationStatus = getQueryStringValue(ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY);
  useEffect(function () {
    fetchCountryData();

    if (!isExperimentLoading) {
      handleOnePassMigrationMessages();
    }
  }, [isExperimentLoading]);
  useEffect(function () {
    if (bannerMessage) {
      setShowAlert(true);
    }
  }, [bannerMessage]);

  var fetchCountryData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$axios$get, _yield$axios$get$data, userCountryName, shouldShopUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isMicrofrontend) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return axios.get("/country.json");

            case 4:
              _yield$axios$get = _context.sent;
              _yield$axios$get$data = _yield$axios$get.data;
              userCountryName = _yield$axios$get$data.userCountryName;
              shouldShopUrl = _yield$axios$get$data.shouldShopUrl;

              if (userCountryName && shouldShopUrl) {
                setBannerMessage(___EmotionJSX(Heading.h3, {
                  fontSize: {
                    xs: "base",
                    lg: "xl"
                  },
                  m: "auto"
                }, "Hi, it looks like you're in ", userCountryName, ", we suggest you shop on", " ", ___EmotionJSX(Link, {
                  color: "#000",
                  textDecoration: "underline",
                  href: "https://".concat(shouldShopUrl, "/")
                }, shouldShopUrl), " ", "instead."));
                setVariant("info");
                setShowAlert(true);
                setTheme("light");
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCountryData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var hideAlert = useCallback(function () {
    setShowAlert(false);
    setBannerMessage("");
  }, []);

  var handleOnePassMigrationMessages = function handleOnePassMigrationMessages() {
    var _window, _window$location, _window2, _window2$location;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) === "/search" || isOnePassAppExperiment && ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname) === "/shop/onepass/") {
      if (paramMigrationStatus === "done") {
        var msg = paramMigrationDoubleSubs === "1" ? FLASH_BANNER_MIGRATION_SUCCESS_DOUBLE_SUB_MSG : FLASH_BANNER_MIGRATION_SUCCESS_MSG;
        setTheme("dark");
        setVariant("success");
        setBannerMessage(msg);
        setTimeout(function () {
          emitMigrationFlashMessageImpression({
            type: "success",
            message: msg
          });
        }, 1000);
      } else if (paramMigrationStatus === "error") {
        setTheme("dark");
        setVariant("error");
        setBannerMessage(FLASH_BANNER_MIGRATION_ERROR_MSG);
        setTimeout(function () {
          emitMigrationFlashMessageImpression({
            type: "error",
            message: FLASH_BANNER_MIGRATION_ERROR_MSG
          });
        }, 1000);
      }
    }
  };

  return ___EmotionJSX(React.Fragment, null, showAlert && bannerMessage && ___EmotionJSX(Alert, {
    type: "inline",
    theme: theme,
    variant: variant,
    showAlertIcon: false,
    showCloseButton: true,
    hideAlert: hideAlert,
    width: "100%"
  }, ___EmotionJSX(Text, {
    fontSize: {
      xs: "sm",
      md: "base"
    },
    fontWeight: 400,
    my: 0,
    mx: {
      lg: "auto"
    }
  }, bannerMessage)));
};
export var FlashMessageBannerWithApollo = withApollo({
  uri: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT
})(FlashMessageBanner);